import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// Numbered step-progress header for the Add Families flow, the same
// step-progress pattern PR #5378 applied to the Import Students page. Making
// billing its own numbered step signals it's a distinct, consequential action.
const DEFAULT_STEPS = ['addFamilies.steps.addStudents', 'addFamilies.steps.setUpBilling', 'addFamilies.steps.review'];

/**
 * `current` is 0-indexed. `steps` defaults to the Add Families labels but can
 * be overridden (e.g. the Add-to-billing flow uses "Select students").
 */
export function WizardSteps({ current, steps = DEFAULT_STEPS }: { current: number; steps?: string[] }) {
  const { t } = useTranslation();
  return (
    <ol className="flex items-center gap-2" data-testid="af-stepper">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <Fragment key={label}>
            <li className="flex flex-none items-center gap-2">
              <span
                className={`flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold ${
                  done || active ? 'bg-blue-900 text-white' : 'border border-gray-300 text-gray-500'
                }`}
              >
                {done ? '✓' : i + 1}
              </span>
              <span className={`text-sm ${active ? 'font-semibold text-navy-950' : 'text-gray-500'}`}>{t(label)}</span>
            </li>
            {i < steps.length - 1 && <li className="h-px w-6 flex-1 bg-gray-200 sm:w-10" aria-hidden />}
          </Fragment>
        );
      })}
    </ol>
  );
}
